import DOMPurify from 'dompurify';
import { ModuleData } from '../../Types/containerV2';
import { isTextModuleContent } from '../../Types/containerV2/modules/text';
import { useContainerContext } from './ContainerContext';
import './TextModule.scss';

type TextModuleProps = {
	module: ModuleData;
};

const TextModule = ({ module }: TextModuleProps) => {
	const { inlineTextEditor } = useContainerContext();

	if (!isTextModuleContent(module.content)) {
		return null;
	}

	if (inlineTextEditor?.activeModuleGuid === module.guid) {
		return <>{inlineTextEditor.renderEditor({ module, content: module.content.text })}</>;
	}

	const sanitizedHtml = DOMPurify.sanitize(module.content.text, {
		// DOMPurify removes target by default. Text-module links need to retain the
		// editor's choice of browsing context, for example target="_blank".
		ADD_ATTR: ['target'],
	});

	return <div className='biz-module biz-text-module' dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default TextModule;
